
import { Component, OnInit, Input } from "@angular/core";
import { DatePipe } from '@angular/common';
import { AuthorizationPipe } from "../../common/pipes/authorization.pipe";
import { AuthorizationExtensionPipe } from "../../common/pipes/authorization-extension.pipe";
import { CustomerService } from "../services/customer.service";
import { Permission } from "../../common/enums/permission.enum";
import { CommonService } from "../../shared/services/common.service";
import { AccessLevel } from "../../common/enums/access-level.enum";

@Component({
    selector: "retail-template",
    templateUrl: "../templates/template1/views/retail.component.html",
    styleUrls: [
        "../templates/template1/themes/default/css/profile-info.less"
    ],
    providers: [AuthorizationPipe, CustomerService, DatePipe,AuthorizationExtensionPipe]
    //encapsulation: ViewEncapsulation.None
})

export class RetailComponent implements OnInit {
    @Input() retailerid: string;
    activeTab = 1;
    retailPermissions: any[] = [Permission.CUSTOMER_DETAILS_VIEW, Permission.CUSTOMER_ORDER_HISTORY_VIEW];
    customerServiceAccessLevelId: number= AccessLevel.Customer_Service;
    constructor(private _commonService: CommonService) { }
    ngOnInit(): void {
        var isRetailProfile = this._commonService.checkPermissionByAccessLevel(JSON.parse("[" + this.retailPermissions[0] + "]"),AccessLevel.Customer_Service);
        this.activeTab = isRetailProfile ? 1 : 2;
    }

};



// WEBPACK FOOTER //
// ./src/app/customerservice/components/retail.component.ts